var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.listColumns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"show-searchbox":true,"show-sync":true,"show-group-actions":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }